import { render, staticRenderFns } from "./Privacy_policy.vue?vue&type=template&id=072a37ca"
import script from "./Privacy_policy.vue?vue&type=script&lang=js"
export * from "./Privacy_policy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports